module.exports = __webpack_public_path__ + "img/AGM.a71b431a.png";